import { Client } from './client';
import { Product } from './product';
import { Ticket } from './ticket';

export enum PurchaseOrderStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Received = 'Received',
  InProgress = 'In Progress',
  Completed = 'Completed'
}

export enum HandlingUnitStage {
  Pending = 'Pending', 
  Received = 'Received',
  Painting = 'Painting',
  Completed = 'Completed'
}

export enum HandlingUnitLocation {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E'
}

export interface PurchaseOrderHistoryEntry {
  timestamp: string;
  action: string;
  user: string;
  details: string;
}

export interface HandlingUnit {
  id: number;
  huNumber: string;
  stage: HandlingUnitStage;
  deliveryDate: string;
  location?: HandlingUnitLocation;
  receivedCount?: number;
  handlingUnitOutboundTruckNumber?: number;
  huTruckDateTime?: string;
  history?: PurchaseOrderHistoryEntry[];
  purchaseOrderItemId: number;
  purchaseOrderItem?: PurchaseOrderItem;
  createdAt?: string;
  updatedAt?: string;
  notes?: string;
}

export interface PurchaseOrderItem {
  id: number;
  itemNumber: string;
  productId?: number;
  product?: Product;
  quantity: string | number;
  unitPrice: string | number;
  unit: string;
  currency: string;
  shipToParty: string;
  batchNumber: string;
  stage: HandlingUnitStage;
  deliveryDate: string;
  purchaseOrderId: number;
  handlingUnits: HandlingUnit[];
  hu: string[]; // Array of handling unit numbers
}

export interface PurchaseOrder {
  id: number;
  poNumber: string;
  status: PurchaseOrderStatus;
  clientId: number;
  client?: Client;
  createdAt: string;
  updatedAt: string;
  approvedAt?: string;
  rejectedAt?: string;
  completedAt?: string;
  notes?: string;
  internalNotes?: string;
  sentToQuickbooks: boolean;
  quickbooksInvoiceId?: string;
  history?: PurchaseOrderHistoryEntry[];
  pdfPath?: string;
  items: PurchaseOrderItem[];
  tickets?: Ticket[];
  needsReview?: boolean;
  reviewReason?: string;
}

export interface UpdatePurchaseOrder {
  poNumber: string;
  notes?: string;
  internalNotes?: string;
  status?: PurchaseOrderStatus;
  history?: PurchaseOrderHistoryEntry[]; // Added history field
  items: UpdatePurchaseOrderItem[];
  replaceItems?: boolean;
  needsReview?: boolean;
  reviewReason?: string;
}

export interface UpdatePurchaseOrderItem {
  id: number;
  itemNumber: string;
  material: string;
  productId?: number;
  quantity: string | number;
  unitPrice: string | number;
  unit: string;
  currency: string;
  shipToParty: string;
  batchNumber: string;
  stage: HandlingUnitStage;
  deliveryDate: string;
  handlingUnits: HandlingUnit[];
  hu: string[]; // Array of handling unit numbers
  replaceHandlingUnits?: boolean;
}

export interface GetPurchaseOrdersParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  search?: string;
  status?: PurchaseOrderStatus;
  clientId?: number;
  fromDate?: string;
  toDate?: string;
}

export interface PurchaseOrdersResponse {
  data: PurchaseOrder[];
  total: number;
  page: number;
  limit: number;
}

export interface CreatePurchaseOrderFromPdfResponse {
  purchaseOrder: PurchaseOrder;
  warnings?: string[];
}

export interface AgingReport {
  fourPlusDays: PurchaseOrder[];
  tenPlusDays: PurchaseOrder[];
}
